





















import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import { NOW_YEAR, thMonthsMini, timeframeSubtract } from '@/utils';

import ChartWithMoneyAxis from '@/components/Vivat/Chart/ChartWithMoneyAxis.vue';

const ChartWithLastYearCompareFailedDelivery = defineComponent({
  components: {
    ChartWithMoneyAxis,
  },
  props: {
    primaryColor: {
      type: String,
      default: 'rgba(18,74,136,255)',
    },
    secondaryColor: {
      type: String,
      default: 'rgba(80,161,242,255)',
    },
    query: {
      default: undefined,
    },
    result: {
      type: Function,
      default: undefined,
    },
    lastYearResult: {
      type: Function,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
    formatYAxis: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const filter = reactive({
      year: {
        from: `${NOW_YEAR}-01-01`,
        to: `${NOW_YEAR}-12-31`,
      },
    });

    const { result, loading } = useQuery(
      props.query as any,
      computed(() => ({
        timeframe: filter.year,
        timeframeY1: timeframeSubtract(filter.year),
      })),
      () => ({
        fetchPolicy: 'network-only',
        enabled: props.query !== undefined && props.result !== undefined && props.lastYearResult !== undefined,
      }),
    );
    const rawData = computed(() => {
      if (loading.value === false && result.value && props.result !== undefined && props.lastYearResult !== undefined) {
        return {
          currentYear: props.result(result.value),
          lastYear: props.lastYearResult(result.value),
        };
      }
      return { currentYear: [], lastYear: [] };
    });
    const mapRawDataIntoFormat = computed(() => {
      const primaryCurrentYear = [];
      const secondaryCurrentYear = [];
      const primaryLastYear = [];
      const secondaryLastYear = [];
      for (let i = 0; i < rawData.value.currentYear.length; i += 1) {
        primaryCurrentYear.push(rawData.value.currentYear[i].lessThanTruckLoaded);
        secondaryCurrentYear.push(rawData.value.currentYear[i].totalLessThanTruckLoaded);
      }
      for (let i = 0; i < rawData.value.currentYear.length; i += 1) {
        primaryLastYear.push(rawData.value.lastYear[i].lessThanTruckLoaded);
        secondaryLastYear.push(rawData.value.lastYear[i].totalLessThanTruckLoaded);
      }
      return {
        primaryCurrentYear,
        secondaryCurrentYear,
        primaryLastYear,
        secondaryLastYear,
      };
    });

    const chartData = computed(() => ({
      labels: thMonthsMini,
      datasets: [
        {
          label: 'LTL (Y-1)',
          data: mapRawDataIntoFormat.value.primaryLastYear,
          backgroundColor: 'rgba(204,205,213,255)',
          stack: 'Y-1',
        },
        {
          label: 'total LTL (Y-1)',
          data: mapRawDataIntoFormat.value.secondaryLastYear,
          backgroundColor: 'rgba(235,234,239,255)',
          stack: 'Y-1',
        },
        {
          label: 'LTL',
          data: mapRawDataIntoFormat.value.primaryCurrentYear,
          backgroundColor: props.primaryColor,
          stack: 'CURRENT',
        },
        {
          label: 'total LTL',
          data: mapRawDataIntoFormat.value.secondaryCurrentYear,
          backgroundColor: props.secondaryColor,
          stack: 'CURRENT',
        },
      ],
    }));

    return {
      filter,
      chartData,
      rawData,
    };
  },
});

export default ChartWithLastYearCompareFailedDelivery;
